import { lazy } from "react";
import Loadable from "app/components/Loadable";

const HmsShellBridgePage = Loadable(
  lazy(() => import("./HmsShellBridgePage")),
);

/**
 * Bridge healthcare-ui menu URIs (/setup/facility, /setup/publish, …) to the HMS
 * setup shell where facility→bed topology and publish already live.
 * Does not re-implement master-data UI.
 */
const MasterBridgeRoutes = [
  {
    path: "/setup/facility",
    element: (
      <HmsShellBridgePage
        title="Facility & bed setup"
        description="Author facility → building → floor → ward → room → bed in the HMS setup shell, then approve and publish so the Inpatient bed board can allocate beds."
      />
    ),
  },
  {
    path: "/setup/governance",
    element: (
      <HmsShellBridgePage
        title="Facility governance"
        description="Approve facility draft batches and topology change-sets before publish."
      />
    ),
  },
  {
    path: "/setup/publish",
    element: (
      <HmsShellBridgePage
        title="Facility publish status"
        description="Hospital ADMIN publishes via Governance workspace (approve changeset → publish delta). This page shows publish status; full-facility break-glass is for platform operators only."
      />
    ),
  },
  {
    path: "/setup/publish/diagnostics",
    element: (
      <HmsShellBridgePage
        title="Publish diagnostics"
        description="Inspect facility publish / projection health for this hospital."
      />
    ),
  },
  {
    path: "/setup/integrity",
    element: (
      <HmsShellBridgePage
        title="Facility integrity"
        description="Facility integrity diagnostics in the HMS setup shell."
      />
    ),
  },
  {
    // FONE:CLINICALSETUP menu URI; canonical owner is the HMS shell (masterGovernanceRegistry).
    path: "/setup/clinical",
    element: (
      <HmsShellBridgePage
        title="Clinical master setup"
        description="Clinical masters are owned by the HMS setup shell."
      />
    ),
  },
];

export default MasterBridgeRoutes;
